function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

export { getHTMLElementScroll as default };
//# sourceMappingURL=getHTMLElementScroll.js.map
